// extracted by mini-css-extract-plugin
export default {"root":"History_root__ozsBm"};